import React, { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Switch } from "components"
import classes from "./SmptAndroidPos.module.scss"
import { addNewPosTerminal, removePosTerminal } from "@redux"

const SmptAndroidPos = () => {
  const i18n = useTranslation()[1]

  const dispatch = useDispatch()

  const accountId =
    useSelector(state => state.userAccountInfo._id)

  const myPosTerminals =
    useSelector(state => state.posTerminals[accountId] || [])

  const handleChange = (name, value, checked) => {
    if (!checked) {
      dispatch(
        removePosTerminal(value, accountId)
      )

      return
    }

    const newPosTerminal = {
      _id: value,
      name,
      value: name,
      terminalName: value,
      type: "androidPos",
      ipAddress: ""
    }

    dispatch(
      addNewPosTerminal(newPosTerminal, accountId)
    )
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div className={classes["card"]}>
        <span
          className={clsx(
            classes["text"],
            isLtr && classes["text-ltr"]
          )}
        >
          کارتخوان سداد
        </span>

        <Switch
          checked={!!myPosTerminals.some(p => p._id === "sadad")}
          onClick={(checked) => handleChange("کارتخوان سداد", "sadad", checked)}
        />
      </div>

      <div className={classes["card"]}>
        <span
          className={clsx(
            classes["text"],
            isLtr && classes["text-ltr"]
          )}
        >
          کارتخوان به پرداخت
        </span>

        <Switch
          checked={!!myPosTerminals.some(p => p._id === "bpMellat")}
          onClick={(checked) => handleChange("کارتخوان به پرداخت", "bpMellat", checked)}
        />
      </div>
    </Fragment>
  )
}

export default SmptAndroidPos